<template>
	<div class="divider-field width-100" />
</template>
<script>
import WidgetFieldMixin from './WidgetFieldMixin';
export default {
	name: 'DividerField',
	mixins: [WidgetFieldMixin],
};
</script>
<style scoped lang="scss">
.divider-field {
	height: 1px;
	margin: 20px 0;
	background: var(--border-color);
}
</style>
